import html2canvas from 'html2canvas'
import PluginLive from '../../../components/Images/PluginLive.png'

const createCircularImage = async (imgSrc, size = 52) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous' // Avoid CORS issues
    img.src = imgSrc

    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      canvas.width = size
      canvas.height = size

      // Create circular clipping mask
      ctx.beginPath()
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2)
      ctx.closePath()
      ctx.clip()

      // Draw the image inside the circle
      ctx.drawImage(img, 0, 0, size, size)

      // Convert to base64 PNG
      resolve(canvas.toDataURL('image/png'))
    }

    img.onerror = err => reject(err)
  })
}

export const PDFHeader = async ({
  pdf,
  headerImage,
  instituteDetails,
  chartElement,
  year,
}) => {
  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const margin = 2
  const contentHeight = 22

  // **Draw Image First**
  pdf.addImage(PluginLive, 'PNG', 10, 10, 20, 5)

  // // **Now Draw Vertical Line After Image**
  pdf.setDrawColor(245, 245, 245)
  pdf.setLineWidth(0.5)

  if (headerImage?.campusLogoRef) {
    const verticalLineX = 40
    const imageX = verticalLineX + 5
    pdf.line(verticalLineX, margin, verticalLineX, margin + contentHeight)

    const canvas = await html2canvas(headerImage?.campusLogoRef, {
      useCORS: true,
    })

    const preferredFormat = 'image/jpeg' // Change to "image/png" or "image/webp" if needed
    const imageData = canvas.toDataURL(preferredFormat, 1.0)
    const jsPDFFormat = preferredFormat.includes('jpeg') ? 'JPEG' : 'PNG'

    pdf.addImage(imageData, jsPDFFormat, imageX, 6, 150, 13)
  }

  const startX = 60 // Adjust as needed
  const maxWidth = 110

  const maxCharacters = 85 // Limit before adding "..."

  // Get the institute name and truncate if needed
  let campusName = instituteDetails?.campusName || ''

  if (campusName.length > maxCharacters) {
    campusName = campusName.substring(0, maxCharacters) + '...'
  }

  // Use splitTextToSize to wrap the (possibly truncated) text
  const wrappedText = pdf.splitTextToSize(campusName, maxWidth)

  // Calculate start Y position dynamically
  const startY = 10 // Adjust threshold as needed
  const totalLetters = wrappedText.reduce(
    (count, line) => count + line.length,
    0
  )
  // Calculate text height
  const textHeight = totalLetters > 40 ? 15 : 12

  // Add University Name
  pdf.setFont('helvetica', 'bold')

  pdf.setTextColor(60, 65, 70) // Lighter than (27, 31, 34)

  pdf.setFontSize(11)
  pdf.text(campusName, startX, startY, { maxWidth })

  // Add Location Below Wrapped Text
  const locationY = textHeight + 5 // Ensure spacing between wrapped text and location

  pdf.setFont('helvetica', 'normal')
  pdf.setTextColor(120, 125, 130) // Much lighter gray
  pdf.setFontSize(10)

  const locationArray = [
    instituteDetails?.city,
    instituteDetails?.state,
  ].filter(Boolean)
  const locationText = locationArray.join(', ')

  pdf.text(locationText, startX, locationY)

  pdf.setTextColor(60, 65, 70)
  // Add Year on Right Side
  pdf.setFont('helvetica', 'bold')
  pdf.setFontSize(14)
  pdf.text(`${year?.year || year}`, 190, 15, { align: 'right' })

  // Draw a full-page border
  pdf.setDrawColor(245, 245, 245) // Gray color
  pdf.setLineWidth(8) // Border thickness
  pdf.rect(5, 31, pageWidth - 10, pageHeight - 36)

  return 50
}
